import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
})
export class LoaderComponent {
  @Input() isLoading: boolean = false;
  @Input() message: string = 'Chargement...';
}
